import React from 'react';
import TocPage from './generic/TocPage';
import getLegalLinks from './Legal/getLegalLinks';

import m306099 from '../media/ift/InternetSat/FormatoSimplificado_306099.pdf';
import m306103 from '../media/ift/InternetSat/FormatoSimplificado_306103.pdf';
import m306350 from '../media/ift/InternetSat/FormatoSimplificado_306350.pdf';
import m306355 from '../media/ift/InternetSat/FormatoSimplificado_306355.pdf';
import m306359 from '../media/ift/InternetSat/FormatoSimplificado_306359.pdf';
import m306144 from'../media/ift/InternetSat/306144.pdf';
import m306361 from'../media/ift/InternetSat/306361.pdf';
import m306153 from'../media/ift/InternetSat/306153.pdf';


import m306225 from '../media/ift/InternetSatF/FormatoSimplificado_306225.pdf';
import m306227 from '../media/ift/InternetSatF/FormatoSimplificado_306227.pdf';
import m306230 from '../media/ift/InternetSatF/FormatoSimplificado_306230.pdf';
import m306233 from '../media/ift/InternetSatF/FormatoSimplificado_306233.pdf';
import m306234 from '../media/ift/InternetSatF/FormatoSimplificado_306234.pdf';
import m306235 from'../media/ift/InternetSatF/306235.pdf';
import m306237 from'../media/ift/InternetSatF/306237.pdf';
import m306238 from'../media/ift/InternetSatF/306238.pdf';




import m1001350 from '../media/ift/InternetSatF/FormatoSimplificado_1001350.pdf';
import m1001333 from '../media/ift/InternetSatF/FormatoSimplificado_1001333.pdf';
import m1001346 from '../media/ift/InternetSatF/FormatoSimplificado_1001346.pdf';
import m1001347 from '../media/ift/InternetSatF/FormatoSimplificado_1001347.pdf';
import m1001338 from '../media/ift/InternetSatF/FormatoSimplificado_1001338.pdf';
import m1001344 from '../media/ift/InternetSatF/FormatoSimplificado_1001344.pdf';
import m1001356 from '../media/ift/InternetSatF/FormatoSimplificado_1001356.pdf';
import m1001361 from '../media/ift/InternetSatF/FormatoSimplificado_1001361.pdf';
import m1001365 from '../media/ift/InternetSatF/FormatoSimplificado_1001365.pdf';
import m1001366 from'../media/ift/InternetSatF/FormatoSimplificado_1001366.pdf';
import m1001367 from'../media/ift/InternetSatF/FormatoSimplificado_1001367.pdf';
import m1001359 from'../media/ift/InternetSatF/FormatoSimplificado_1001359.pdf';





const Rates = props => {
    return (
        <div id='rates' className='container p-4'>
            <TocPage history={props.history} links={getLegalLinks()}>
                <h4 className='mb-4'>REGISTRO DE TARIFAS ANTE IFT</h4>





                <table className='table table-striped table-bordered'>
                    <thead className='thead-dark'>

                    </thead>
                    <tbody>
                        <tr className='thead-dark'>
                            <th className='td-title' colspan="2">ON SATELITAL</th>
                        </tr>
                        <tr className='thead-dark'>
                            <th>NOMBRE</th>
                            <th>TARIFA</th>
                        </tr>

                        <tr><td>ON Satelital internet 3 con 5 GB </td>
                            <td><a href={m1001350} target='_blank' rel='noopener noreferrer'>1001350</a></td>
                        </tr>
                        
                       
                        <tr><td>ON Satelital internet 30 con 100 GB  </td>
                            <td><a href={m1001338} target='_blank' rel='noopener noreferrer'>1001338</a></td>
                        </tr>
                        <tr><td>ON Satelital internet 30 con 150 GB </td>
                            <td><a href={m1001344} target='_blank' rel='noopener noreferrer'>1001344</a></td>
                        </tr>
                        <tr><td>ON Satelital internet 25 con 20 GB   </td>
                            <td><a href={m1001333} target='_blank' rel='noopener noreferrer'>1001333</a></td>
                        </tr>
                        <tr><td>ON Satelital internet 30 con 100 GB   </td>
                            <td><a href={m306144} target='_blank' rel='noopener noreferrer'>306144</a></td>
                        </tr>
                        <tr><td>ON Satelital internet 30 con 150 GB   </td>
                            <td><a href={m306361} target='_blank' rel='noopener noreferrer'>306361</a></td>
                        </tr>
                        <tr><td>ON Satelital internet 25 con 20 GB   </td>
                            <td><a href={m306153} target='_blank' rel='noopener noreferrer'>306153</a></td>
                        </tr>
                        <tr><td>ON Satelital internet 25 con 40 GB   </td>
                            <td><a href={m1001346} target='_blank' rel='noopener noreferrer'>1001346</a></td>
                        </tr>
                        <tr><td>ON Satelital internet 25 con 60 GB   </td>
                            <td><a href={m1001347} target='_blank' rel='noopener noreferrer'>1001347</a></td>
                        </tr>

                        <th className='td-title' colspan="2">Paquetes GB adicionales que aplican para todos los paquetes</th>

                        <tr><td>Paquete adicional 1 GB </td>
                            <td><a href="https://tarifas.ift.org.mx/ift_visor/" target='_blank' rel='noopener noreferrer'>359574</a></td>
                        </tr>
                        <tr><td>Paquete adicional 3 GB</td>
                            <td><a href="https://tarifas.ift.org.mx/ift_visor/" target='_blank' rel='noopener noreferrer'>359578</a></td>
                        </tr>
                        <tr><td>Paquete adicional 5 GB   </td>
                            <td><a href="https://tarifas.ift.org.mx/ift_visor/" target='_blank' rel='noopener noreferrer'>359582</a></td>
                        </tr>
                        <tr><td>Paquete adicional 10 GB   </td>
                            <td><a href="https://tarifas.ift.org.mx/ift_visor/" target='_blank' rel='noopener noreferrer'>359583</a></td>
                        </tr>

                    </tbody>
                </table>





                <table className='table table-striped table-bordered'>
                    <thead className='thead-dark'>

                    </thead>
                    <tbody>

                        <tr className='thead-dark'>
                            <th className='td-title' colspan="2">ON SATELITAL FRANJA FRONTERIZA</th>
                        </tr>
                        <tr className='thead-dark'>
                            <th>NOMBRE</th>
                            <th>TARIFA</th>
                        </tr>
                        <tr><td>ON Satelital internet 3 con 5 GB </td>
                            <td><a href={m1001356} target='_blank' rel='noopener noreferrer'>1001356</a></td>
                        </tr>
                       
                        <tr><td>ON Satelital internet 30 con 100 GB  </td>
                            <td><a href={m1001366} target='_blank' rel='noopener noreferrer'>1001366</a></td>
                        </tr>
                        <tr><td>ON Satelital internet 30 con 150 GB </td>
                            <td><a href={m1001367} target='_blank' rel='noopener noreferrer'>1001367</a></td>
                        </tr>
                        <tr><td>ON Satelital internet 25 con 20 GB   </td>
                            <td><a href={m1001359} target='_blank' rel='noopener noreferrer'>1001359</a></td>
                        </tr>
                        <tr><td>ON Satelital internet 30 con 100 GB   </td>
                            <td><a href={m306235} target='_blank' rel='noopener noreferrer'>306235</a></td>
                        </tr>
                        <tr><td>ON Satelital internet 30 con 150 GB   </td>
                            <td><a href={m306237} target='_blank' rel='noopener noreferrer'>306237</a></td>
                        </tr>
                        <tr><td>ON Satelital internet 25 con 20 GB   </td>
                            <td><a href={m306238} target='_blank' rel='noopener noreferrer'>306238</a></td>
                        </tr>
                        <tr><td>ON Satelital internet 25 con 40 GB   </td>
                            <td><a href={m1001361} target='_blank' rel='noopener noreferrer'>1001361</a></td>
                        </tr>
                        <tr><td>ON Satelital internet 25 con 60 GB   </td>
                            <td><a href={m1001365} target='_blank' rel='noopener noreferrer'>1001365</a></td>
                        </tr>

                        <th className='td-title' colspan="2">Paquetes GB adicionales que aplican para todos los paquetes</th>

                        <tr><td>Paquete adicional 1 GB </td>
                            <td><a href="https://tarifas.ift.org.mx/ift_visor/" target='_blank' rel='noopener noreferrer'>359587</a></td>
                        </tr>
                        <tr><td>Paquete adicional 3 GB</td>
                            <td><a href="https://tarifas.ift.org.mx/ift_visor/" target='_blank' rel='noopener noreferrer'>359590</a></td>
                        </tr>
                        <tr><td>Paquete adicional 5 GB   </td>
                            <td><a href="https://tarifas.ift.org.mx/ift_visor/" target='_blank' rel='noopener noreferrer'>359596</a></td>
                        </tr>
                        <tr><td>Paquete adicional 10 GB   </td>
                            <td><a href="https://tarifas.ift.org.mx/ift_visor/" target='_blank' rel='noopener noreferrer'>359603</a></td>
                        </tr>

                    </tbody>
                </table>



            </TocPage>
        </div>
    );
}

export default Rates;



// WEBPACK FOOTER //
// ./src/components/Rates_sat.js